<style lang="scss" scoped>

    .myAmpleon .main .container {
        width: auto;
    }

    .myAmpleon .content {
        @media screen and (max-width: 767px) {
            margin-top: 0;
        }
    }

    h3.page-title {
        color: #000 !important;
        font-size: 24px;
        line-height: 29px;
    }

    .sidebar, .banner {
        display: none;
    }

    .content {
        left: 0;
        width: 100% !important;
    }

    .row__registration-successful {
        min-height: 100vh;

        @media (max-width: 991px) {
            flex-direction: column-reverse;
            min-height: auto;
        }

        .parametric-intro {
            margin: 0;
        }

        .page-title {

            @media (max-width: 767px) {
                padding: 15px 0 !important;
            }
        }

        .image-section {

            @media (max-width: 991px) {
                height: 270px;
            }

            @media (max-width: 767px) {
                height: 402px;
            }
        }
    }

    .top-bar {
        background-color: #003b71;
        height: 60px;
        width: 100%;
        top: 50px;
        left: 0;
        z-index: 2;
        overflow: hidden;
    }

    .row--flex {
        display: flex;
        flex-wrap: wrap;
        margin: 0;
    }

    .image-section {
        display: flex;
        flex-direction: column;
        font-family: "Open Sans", sans-serif;
        position: relative;
        height: 100vh;
        background-image: url("../assets/images/register-img.jpg");
        background-position: center;
        -webkit-background-size: cover;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .overlay {
        opacity: 0.8;
        color: #fff;
        background: #003B71;
        width: 100%;
        height: 100%;
        z-index: 1;
        position: absolute;
        left: 0;
        top: 0;
    }

    .svg-wrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 300px;
        height: 170px;

        path {
            fill: #ffffff;
        }
    }

    .col-spacing-75 {
        padding: 0 75px;

        @media (max-width: 991px) {
            padding: 0 25px;
        }

        @media (max-width: 767px) {
            padding: 0 15px;
        }
    }

    .form-check-label {
        margin: 0 0 0 20px;
        font-size: 12px;
        font-weight: 300;
        line-height: 13px;
        transform: translateY(-2px);
    }

    .form-textarea {
        width: 100%;
    }

    .invalid-feedback {
        color: red;
        margin-left: 12px;
        margin-bottom: 0;
    }

    .parametric-intro {
        margin: 0;
        padding-top: 43px !important;
    }

    .label-forgot-pass {
        float: right;
        font-weight: bold;
    }

    .login-question {
        margin-bottom: 48px;
    }

    .account-question-paragraph {
        font-size: 15px;
        font-weight: bold;
        line-height: 13px;
    }

    .login-button {
        padding-left: 35px;
        padding-right: 35px;
    }

    .registration-problems {
        margin-top: 40px;
        font-weight: bold;
    }

    .form-control {
        padding: 5px 18px;
        border-color: #ddd;
        box-shadow: none;
        font-size: 14px;
        line-height: 20px;

        &::-webkit-input-placeholder { /* Edge */
            color: #000;
            font-size: 14px;
            font-weight: lighter;
        }

        &:-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: #000;
            font-size: 14px;
            font-weight: lighter;
        }

        &::placeholder {
            color: #000;
            font-size: 14px;
            font-weight: lighter;
        }
    }
</style>

<template>
    <div class="registration-wrapper">
        <div class="top-bar"></div>
        <div class="row row--flex row__registration-successful">
            <div class="col-md-6 col-spacing-75">
                <div class="parametric-intro">
                    <h3 class="page-title">myAmpleon Login</h3>
                </div>

                <div class="login-question">
                    <p class="account-question-paragraph">Don't have an account?
                        <router-link :to="{path: '/registration'}">Register now</router-link>
                    </p>
                </div>

                <form @submit.prevent="handleSubmit">
                    <div class="row form-row">
                        <div class="form-group col-md-12">
                            <input type="text" v-model="user.email" class="form-control" id="inputEmail"
                                   placeholder="Email *"
                                   :class="{ 'is-invalid': formErrors && $v.user.email.$error }">
                            <p v-if="formErrors && !$v.user.email.required" class="invalid-feedback">E-mail address
                                is required.</p>
                            <p v-if="formErrors && !$v.user.email.email" class="invalid-feedback">E-mail address is
                                required.</p>
                        </div>

                        <div class="form-group col-md-12">
                            <input type="password" v-model="user.password" class="form-control" id="inputPassword4"
                                   placeholder="Password *"
                                   @keyup="checkCapsLock"
                                   @mousedown="checkCapsLock"
                                   :class="{ 'is-invalid': formErrors && $v.user.password.$error }">
                            <p v-if="formErrors && !$v.user.password.required" class="invalid-feedback">Password is
                                required.</p>
                            <p v-if="capsLockWarning" class="invalid-feedback">Warning: Caps lock is on.</p>
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="form-group form-group-check-second col-md-12">
                            <div class="form-check pull-right">
                                <router-link
                                        class="link-forgot-password form-check-label custom-control-label label-forgot-pass"
                                        :to="{path: '/reset-password'}">Forgot Password?
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="form-group col-md-12">
                            <p v-if="loginFailed" class="invalid-feedback">Invalid email and/or password. Please try again.</p>
                            <p v-if="activationError" class="invalid-feedback">Cannot activate the user. Either the user is already activated or the user doesn't exist</p>
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="form-group col-md-12">
                            <button type="submit" :disabled="isPending"
                                    class="btn btn-primary">Login
                            </button>
                        </div>
                    </div>

                </form>

                <div class="row form-row registration-problems">
                    <div class="form-group col-md-12">
                        <router-link :to="{path: '/registration-and-login-support'}">Problems with Login?</router-link>
                    </div>
                </div>
            </div>

            <div class="col-md-6 image-section">
                <div class="overlay">
                    <div class="svg-wrapper">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             viewBox="0 0 302 172" style="enable-background:new 0 0 302 172;" xml:space="preserve">
                            <path fill="#ffffff" class="st0" d="M151,0.9c21.6,0,31.3,11,34.8,38.1L198,139.2c1,8.1,1.9,9.3,5.8,9.3c3.3,0,4.4-1.2,5.4-9.3l12.2-100.1
                                c3.3-27.2,13.7-38.1,34.8-38.1c23,0,33.4,11,35.4,38.1l9.1,120c0.8,9.5-1.7,12-11.2,12h-3.9c-9.5,0-12-2.3-12.6-12l-8.3-119.8
                                c-0.8-11.2-3.1-14.1-9.1-14.1c-5.2,0-7.9,2.9-9.1,14.1l-14.1,104.3c-2.9,20.5-9.1,27.6-28.8,27.6c-17.4,0-25.9-6.8-28.8-27.6
                                L160.5,39.3c-1.2-11.2-3.9-14.1-9.3-14.1h-0.4c-5.4,0-8.1,2.9-9.3,14.1l-14.3,104.3c-2.9,20.7-11.4,27.6-28.8,27.6
                                c-19.7,0-25.9-7-28.8-27.6L55.5,39.3c-1.2-11.2-3.9-14.1-9.1-14.1c-6,0-8.3,2.9-9.1,14.1l-8.3,119.8c-0.8,9.5-3.1,12-12.6,12h-3.9
                                c-9.5,0-12-2.3-11.2-12l9.1-120C12.3,11.9,22.7,0.9,45.7,0.9c20.9,0,31.3,11,34.8,38.1l12.2,100.1c1,8.1,2.1,9.3,5.4,9.3
                                c3.9,0,4.8-1.2,5.8-9.3l12.2-100.1C119.7,11.7,129.4,0.9,151,0.9z"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {required, email} from "vuelidate/lib/validators";
    import {LOGIN_USER, FINALIZE_ACTION} from "../store/actions.type";
    import {STATUS, mapAsyncGetters} from "../store/utils/async";
    import {UserService} from "../common/api.service";

    export default {
        name: "Login",
        data() {
            return {
                user: {
                    email: "",
                    password: ""
                },
                userActivation: {
                    email: "",
                    activationToken: "",
                },
                formErrors: false,
                loginFailed: false,
                activationError: false,
                capsLockWarning: false,
            };
        },
        validations: {
            user: {
                email: {required, email},
                password: {required}
            }
        },
        computed: {
            ...mapAsyncGetters(LOGIN_USER)
        },
        watch: {
            status: function (newValue) {
                if (this.isFinished) {
                    if (newValue === STATUS.SUCCESS) {
                        if (typeof (this.$route.query.redirectDoc) !== "undefined" &&
                            this.$route.query.redirectDoc.startsWith(window.location.origin)) {
                            window.location.href = this.$route.query.redirectDoc.toString();
                        } else {
                            this.$router.push({name: this.$route.query.redirect || 'dashboard-page'});
                        }
                    } else if (newValue === STATUS.FAILURE) {
                        this.loginFailed = true;
                    }
                }
            }
        },
        async mounted() {
            //activate the user if activation params are sent.
            if (this.$route.query.email && this.$route.query.activationToken) {
                // '+' is url encoded to '%20' in browsers' address bar, and the '%20' is then decoded to ' '.
                this.userActivation.email = this.$route.query.email.trim().replace(' ', '+');
                this.userActivation.activationToken = this.$route.query.activationToken;

                await UserService.activateUser(this.userActivation)
                    .then(response => {
                        if (response.status !== 200) {
                            this.activationError = true;
                        }
                    })
                    .catch(error => {
                        this.activationError = true;
                    });
            }
        },
        methods: {
            handleSubmit(e) {
                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.formErrors = true;
                } else {
                    this.$store.dispatch(LOGIN_USER, this.user)
                        .then(response => {
                            if (response) {
                                this.$router.push(response);
                            }

                            return this.$store.dispatch(FINALIZE_ACTION, LOGIN_USER);
                        })
                }
            },
            checkCapsLock(e) {
                this.capsLockWarning = e.getModifierState('CapsLock') === true;
            }
        }
    };
</script>

